"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withWidth = require("@material-ui/core/withWidth");

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _excluded = ["children", "history", "tabs", "appBarProps", "width", "fullWidth", "evenWidth", "onTabChange", "activeTab", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    title: {},
    tabs: {
      width: '100%',
      flexGrow: 1
    },
    bigTabs: {
      minHeight: theme.heights.toolbarBottom
    },
    appBar: {
      position: 'static',
      // TODO: remove after SimpleAppBar className prop fix
      zIndex: 2,
      boxShadow: 'none'
    },
    extraToolbar: {
      paddingLeft: 0,
      paddingRight: 0
    },
    scrollContainer: {}
  };
});

var TabView = function TabView(_ref) {
  var children = _ref.children,
      history = _ref.history,
      tabs = _ref.tabs,
      appBarProps = _ref.appBarProps,
      width = _ref.width,
      fullWidth = _ref.fullWidth,
      evenWidth = _ref.evenWidth,
      onTabChange = _ref.onTabChange,
      controlledActiveTab = _ref.activeTab,
      eClasses = _ref.classes,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    classes: eClasses
  });

  var _useState = (0, _react.useState)({
    activeTab: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var activeTab = controlledActiveTab || state.activeTab || props["default"] || tabs && Object.keys(tabs)[0];

  var handleTabChange = function handleTabChange(event, activeTab) {
    setState({
      activeTab: activeTab
    });
  };

  var Comp = tabs[activeTab].component;
  var scrollable = !tabs[activeTab].dontWrap;
  var isPhone = (0, _withWidth.isWidthDown)('xs', width);

  var TabsC = /*#__PURE__*/_react["default"].createElement(_core.Tabs, _extends({
    fullWidth: fullWidth
  }, props, {
    value: activeTab,
    indicatorColor: "secondary",
    onChange: onTabChange || handleTabChange,
    classes: {
      root: (0, _classnames["default"])(classes.tabs, !isPhone && classes.bigTabs)
    }
  }), Object.keys(tabs).map(function (t) {
    return tabs[t].label && /*#__PURE__*/_react["default"].createElement(_core.Tab, {
      classes: {
        root: !isPhone && classes.bigTabs
      },
      className: (0, _classnames["default"])(classes.tabButton, fullWidth && evenWidth && classes.evenWidth),
      label: tabs[t].label,
      value: t
    });
  }));

  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, _extends({
    fullColumn: true,
    classes: {
      root: classes.root
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, _extends({
    titleOnTop: false,
    extraToolbar: !isPhone && TabsC,
    classes: {
      extraToolbar: classes.extraToolbar
    }
  }, appBarProps)), isPhone && TabsC, children || (scrollable ? /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, {
    classes: {
      root: classes.scrollContainer
    }
  }, Comp) : Comp));
};

TabView.propTypes = {
  "default": _propTypes["default"].string,
  evenWidth: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  tabs: _propTypes["default"].object.isRequired
};
TabView.defaultProps = {
  fullWidth: true,
  evenWidth: true
};
var _default = TabView;
exports["default"] = _default;